<!--
<div class="card card-outline card-primary">
    <div class="card-header text-center">
        <div class="row">
            <div class="col-md-12">
                <img src="./assets/img/mykadainew.png" style="height:80px;width:80px;">
            </div>
        </div>
    </div>
    <div class="card-body">
        <p class="login-box-msg"><b>WELCOME</b></p>
        <p class="login-box-msg"><b>LOGIN TO CONTINUE</b></p>

        <form [formGroup]="loginForm" id="loginForm" (ngSubmit)="onSubmit()">
            <div class="input-group mb-3">
                <input
                    formControlName="userName" id="userName" [(ngModel)]="userName"
                    type="text"
                    class="form-control"
                    placeholder="User Name"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-user"></span>
                    </div>
                </div>
            </div>
            <span *ngIf="loginErrors.userName" class="error-text">{{loginErrors.userName}}</span>
            <div class="input-group mb-3">
                <input
                    formControlName="password" id="password" [(ngModel)]="password"
                    type="password"
                    class="form-control"
                    placeholder="Password"minlength="8" maxlength="15"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <i class="toggle-password fa fa-lock-open" data-toggle="tooltip" data-placement="top" title="Click to Show Password" (click)="togglePasswordVisibility()" [ngClass]="{'fa-lock-open': isPasswordVisible, 'fa-lock': !isPasswordVisible}" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            <span *ngIf="loginErrors.password" class="error-text">{{loginErrors.password}}</span>
            <div class="row">
                &lt;!&ndash;<div class="col-7">
                    <div class="icheck-primary">
                        <input type="checkbox" id="rememberMe" formControlName="rememberMe" [(ngModel)]="rememberMe"/>
                        <label for="rememberMe" style="font-family: 'Times New Roman'"> Remember Me </label>
                    </div>
                </div>&ndash;&gt;
                &lt;!&ndash; /.col &ndash;&gt;
                <div class="col-md-12 btn-block mb-3">
                    &lt;!&ndash;<pf-button
                        type="submit"
                        [block]="true"
                        [loading]="isAuthLoading"
                        [disabled]="isFacebookLoading || isGoogleLoading"
                    ><span class="font-weight-bolder">LOG IN</span></pf-button>&ndash;&gt;
                    <button type="submit" class="btn btn-primary btn-block">Log In</button>
                </div>
            </div>
            &lt;!&ndash; <div class="social-auth-links text-center mb-3">
                <span class="mb-1">- or -</span>
                <pf-button
                        class="mb-2"
                        [block]="true"
                        [loading]="isFacebookLoading"
                        [disabled]="isAuthLoading || isGoogleLoading"
                        (click)="loginByFacebook()"
                >
                    <i class="fab fa-facebook mr-2"></i>
                    Sign in using Facebook
                </pf-button>
                <pf-button
                        [block]="true"
                        [loading]="isGoogleLoading"
                        [disabled]="isAuthLoading || isFacebookLoading"
                        theme="danger"
                        (click)="loginByGoogle()"
                >
                    <i class="fab fa-google mr-2"></i>
                    Sign in using Google+
                </pf-button>
            </div> &ndash;&gt;
        </form>
        <div class="row mt-3">
            <div class="col-md-12 text-center">
                <label>Not a Member?</label>
                <a [routerLink]="['/shop-owner-register']" class="text-center">
                                    Register
                                </a>
            </div>
        </div>

        &lt;!&ndash;<p class="mb-1">
            <a [routerLink]="['/forgot-password']">I forgot my password</a>
        </p>&ndash;&gt;
&lt;!&ndash;        <p class="mb-0">&ndash;&gt;
&lt;!&ndash;            <a [routerLink]="['/shop-owner-register']" class="text-center">&ndash;&gt;
&lt;!&ndash;                Register a New Membership&ndash;&gt;
&lt;!&ndash;            </a>&ndash;&gt;
&lt;!&ndash;        </p>&ndash;&gt;
        &lt;!&ndash; <p class="mb-1">
            <a [routerLink]="['/shopownerregister']">Register Shop Owner</a>
        </p> &ndash;&gt;
        &lt;!&ndash; <div class="row mt-3">
            <div class="col-md-12 text-center">
                <label>Not a Member?</label>
             <label class="text-align" type="button" (click)="onNavigation('shop-owner-register')">Register</label>
            </div>
        </div> &ndash;&gt;
        &lt;!&ndash;<div class="text-center">
            <p class="text-center text-muted mt-2 mb-0">Not a Member? <a class="text-align" type="button" data-toggle="tooltip" data-placement="top" title="Click to start your Registration" (click)="onNavigation('shop-owner-register')">Register</a></p>
        </div>&ndash;&gt;
    </div>
    &lt;!&ndash; /.login-card-body &ndash;&gt;
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>
-->

<!--
<div [style.display]="'block'" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="card-header text-center">
                <div class="row">
                    <div class="col-md-12">
                        <img src="./assets/img/mykadainew.png" style="height:80px;width:80px;">
                    </div>
                </div>
            </div>
            <h5 class="text-center mt-3 font-weight-bold">REGISTER</h5>
            <div class="modal-body">
                <div style="border-color:#e9ecef #e9ecef #dee2e6 !important;padding: 10px;">
                    <form (ngSubmit)="onSubmit()" [formGroup]="shopOwnerDetails" id="shopOwnerDetails">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control text-capitalize" placeholder="First Name"
                                           id="firstName" formControlName="firstName">
                                    <span *ngIf="shopOwnerRegisterErrors.firstName"
                                          class="error-text">{{shopOwnerRegisterErrors.firstName}}</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control text-capitalize" placeholder="Last Name"
                                           id="lastName"
                                           formControlName="lastName">
                                    <span *ngIf="shopOwnerRegisterErrors.lastName"
                                          class="error-text">{{shopOwnerRegisterErrors.lastName}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Email Address" id="emailId"
                                           formControlName="emailId">
                                    <span *ngIf="shopOwnerRegisterErrors.emailId"
                                          class="error-text">{{shopOwnerRegisterErrors.emailId}}</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control"
                                           placeholder="Phone Number" id="phoneNumber" formControlName="phoneNumber"
                                           (keypress)="OnlyNumbers($event)" maxlength="10">
                                    <span *ngIf="shopOwnerRegisterErrors.phoneNumber"
                                          class="error-text">{{shopOwnerRegisterErrors.phoneNumber}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="User Name" id="userName"
                                           formControlName="userName" maxlength="20" autocomplete="new-userName">
                                    <span *ngIf="shopOwnerRegisterErrors.userName"
                                          class="error-text">{{shopOwnerRegisterErrors.userName}}</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="password" class="form-control" [(ngModel)]="password"
                                           autocomplete="new-password"
                                           placeholder="Password" id="password" formControlName="password" minlength="8"
                                           maxlength="10">
                                    <i class="toggle-password fa fa-eye" data-toggle="tooltip" data-placement="top"
                                       title="Click to Show Password" (click)="togglePasswordVisibility()"
                                       [ngClass]="{'fa-eye-slash': isPasswordVisible, 'fa-eye': !isPasswordVisible}"
                                       aria-hidden="true"></i>
                                    <span *ngIf="shopOwnerRegisterErrors.password"
                                          class="error-text">{{shopOwnerRegisterErrors.password}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 form-group">
                            <input type="checkbox" id="enabled" formControlName="enabled">
                            <label class="ml-2"> I agree to the <a href="" data-toggle="modal" data-target="#myModal">Terms
                                &
                                Condition</a></label><br>
                            <span *ngIf="shopOwnerRegisterErrors.enabled"
                                  class="error-text">{{shopOwnerRegisterErrors.enabled}}</span>
                        </div>
                        <div class="text-center mt-1">
                            <button type="submit" class="btn btn-success font-weight-bolder btn-block mb-3">REGISTER
                            </button>
                        </div>
                    </form>
                    &lt;!&ndash; <div class="row">
                       <label class="text-align col-md-12 mt-3" type="button" (click)="onNavigation('login')">login</label>
                       </div> &ndash;&gt;
                    <p class="text-center text-muted mt-3 mb-0">Have already an account?
                        <a class="text-md-center font-weight-bold text-success" type="button" [routerLink]="['/']">Login
                            here</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>-->

<div class="register-container">
    <div class="left-panel d-none d-md-block">
        <div class="overlay">
            <h3 class="font-weight-bolder mb-3">Welcome Back</h3>
            <img src="assets/img/mykadainew.png" class="img-fluid register-logo" [routerLink]="['/']" type="button">
        </div>
    </div>
    <div class="right-panel">
        <form [formGroup]="loginForm" id="loginForm" (ngSubmit)="onSubmit()">
            <div class="text-center d-lg-none d-block">
                <img src="assets/img/mykadainew.png" class="img-fluid" style="height: 100px" [routerLink]="['/']" type="button">
            </div>
            <h3 class="text-center mb-4">Login</h3>
            <div class="form-floating mb-3">
                <input type="text" class="form-control" id="userName" placeholder="Registered Phone Number" maxlength="10"
                       formControlName="userName" (keypress)="OnlyNumbers($event)" [ngClass]="{
                 'is-invalid': loginForm.get('userName')?.invalid && loginForm.get('userName')?.touched,
                 'is-valid': loginForm.get('userName')?.valid && loginForm.get('userName')?.touched
               }">
                <label for="userName">Registered Phone Number</label>
                <span *ngIf="loginErrors.userName"
                      class="error-text">{{ loginErrors.userName }}</span>
            </div>

            <div class="form-floating mb-3 position-relative">
                <input [type]="isPasswordVisible ? 'text' : 'password'" class="form-control" id="password"
                       placeholder="Password" formControlName="password" [(ngModel)]="password" [ngClass]="{
                 'is-invalid': loginForm.get('password')?.invalid && loginForm.get('password')?.touched,
                 'is-valid': loginForm.get('password')?.valid && loginForm.get('password')?.touched
               }">
                <label for="password">Password</label>
                <i class="toggle-password fa"
                   [ngClass]="{'fa-eye': !isPasswordVisible, 'fa-eye-slash': isPasswordVisible}"
                   style="cursor:pointer;" (click)="togglePasswordVisibility()"></i>
            </div>
            <span *ngIf="loginErrors.password"
                  class="error-text">{{ loginErrors.password }}</span>

            <button type="submit" class="btn btn-primary w-100">Login</button>
            <p class="text-center text-muted mt-3 mb-0">
                Forgot Password?
                <a class="text-primary fw-bold" [routerLink]="['/forgot-password']">Forgot Password</a>
            </p>
            <p class="text-center text-muted mt-3 mb-0">
                New to My Kadai?
                <a class="text-primary fw-bold" [routerLink]="['/shop-owner-register']">Regsiter</a>
            </p>
        </form>
    </div>
</div>

<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>


